module.exports = __webpack_public_path__ + "img/lt.793eda52.svg";